import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import {
  Switch,
  Route,
  useRouteMatch,
  useHistory,
} from "react-router-dom";
import types from '../../types';
import styles from './styles.module.scss';

// Make sure to bind modal to your appElement (http://reactcommunity.org/react-modal/accessibility/)
Modal.setAppElement('#root');

const AbstractModalView = ({
                             triggerContent,
                             modalContent,
                             customContentClassName = '',
                             customModalClassName = '',
                             currentLocale,
                             subPath = 'info'
                           }) => {
  const {path, url} = useRouteMatch();
  const history = useHistory();
  const openModal = () => history.push(`${url}/${subPath}`);
  const closeModal = () => {
    history.goBack();
  };
  const contentDirection = (currentLocale === 'he') ? 'rtl' : 'ltr';

  return (
    <>
      {triggerContent({openModal})}
      <Switch>
        <Route path={`${path}/${subPath}`}>
          <Modal
            isOpen={true}
            onRequestClose={closeModal}
            className={`${styles.modal} ${styles[contentDirection]} ${customModalClassName}`}
            overlayClassName={styles.overlay}
          >
            <div dir={contentDirection} className={`${styles.modalContainer} ${customContentClassName}`}>
              {modalContent({closeModal})}
            </div>
          </Modal>
        </Route>
      </Switch>
    </>
  );
};

const {children} = types.children;

AbstractModalView.propTypes = {
  triggerContent: children,
  modalContent: children,
  currentLocale: PropTypes.string
};

export default AbstractModalView;
